import {handleSend} from '../../api/erp/post'

//
//   *进销存管理(6) *
//
// 进销存相关下拉框列表接口（60,0000）
const queryErpDropDown = (listNo, CoditionList) => {
  let data = {listNo: listNo, coditionList: CoditionList}
  return handleSend(data, '60', '0000', '0', 'Alert')
}

// 1.登录用户管理的仓库列表
// 列表编码：000
const getUserStoreHouseList = (CoditionList) => {
  return queryErpDropDown('000', CoditionList)
}

// 2.所属商户下仓库列表
// 列表编码：001
const getStoreHouseListByMerchId = (CoditionList) => {
  return queryErpDropDown('001', CoditionList)
}

// 3.仓库下货架列表
// 列表编码：002
const getShelvesListBySoreHouseId = (CoditionList) => {
  return queryErpDropDown('002', CoditionList)
}

// 4.所属商户下供货商列表
// 列表编码：003
const getSupplierListByMerchId = (CoditionList) => {
  return queryErpDropDown('003', CoditionList)
}

// 5.仓库下供货商列表
// 列表编码：004
const getSupplierListByStoreHouseId = (CoditionList) => {
  return queryErpDropDown('004', CoditionList)
}

// 6.所属商户下商品品牌列表
// 列表编码：005
const getBrandListByMerchId = (CoditionList) => {
  return queryErpDropDown('005', CoditionList)
}

// 7.仓库下商品品牌列表
// 列表编码：006
const getBrandListByStoreHouseId = (CoditionList) => {
  return queryErpDropDown('006', CoditionList)
}

// 8.所属仓库下商品列表
// 列表编码：007
const getGoodListByStoreHouseId = (CoditionList) => {
  return queryErpDropDown('007', CoditionList)
}

// 9.采购进货单列表
// 列表编码：008
const getPurOrderListByStoreHouseIdAndSupplierId = (CoditionList) => {
  return queryErpDropDown('008', CoditionList)
}

export const ErpApi = {
  getUserStoreHouseList,
  getStoreHouseListByMerchId,
  getShelvesListBySoreHouseId,
  getSupplierListByMerchId,
  getSupplierListByStoreHouseId,
  getBrandListByMerchId,
  getBrandListByStoreHouseId,
  getGoodListByStoreHouseId,
  getPurOrderListByStoreHouseIdAndSupplierId
}



// WEBPACK FOOTER //
// ./src/request/Erp/erp_api.js